import styled from 'styled-components'

interface CenteredProps {
  vertically?: boolean
  horizontally?: boolean
  fullHeight?: boolean
  fullWidth?: boolean
}

export default styled.div`
  ${(props: CenteredProps) => ''};

  display: flex;
  align-items: ${({ vertically }) => vertically && 'center'};
  justify-content: ${({ horizontally }) => horizontally && 'center'};
  height: ${({ fullHeight }) => fullHeight && '100%'};
  width: ${({ fullWidth }) => fullWidth && '100%'};
`



// WEBPACK FOOTER //
// ./src/components/atoms/Centered.ts